module.exports = __webpack_public_path__ + "static/img/WeChat.ed8153ce.png";